import { useState, useEffect } from 'react';
import axiosInstance from '../../helpers/axios';
import DatePicker from "react-multi-date-picker";
import calender from "../../assets/images/calender.png";
import download from "../../assets/images/download.png";
import moment from 'moment';
import PaginationTable from "../status/PaginationTable";
import { useSelector } from "react-redux";



export default function Closedloans() {
  const [Closeddata, setclosedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [totalFetchRows, setTotalFetchRows] = useState(0);
    const [ClosedstartDate,setClosedStartDateFrom] = useState()
    const [ClosedendDate,setclosedEndDateTo] = useState()
  const [activePage, setActivePage] = useState(15);

    const user = null;
  const productTypeSelected = useSelector((state) => state.ProductTypeFilter.selectedProductType);


    useEffect(() => {
      
        const startDateFrom = moment().startOf('month');
        const endDateTo = moment();
    
      
        const formattedStartDate = startDateFrom.format('YYYY-MM-DD');
        const formattedEndDate = endDateTo.format('YYYY-MM-DD')+ " 23:59:59";
    
        let queryParams = {
          startDate: formattedStartDate,
          endDate: formattedEndDate,
          perPage: rowsPerPage,
          pageNo: currentPage,
        };
      if (productTypeSelected && productTypeSelected !== "all") {
        queryParams.loanType = Number(productTypeSelected);
      }
        axiosInstance.get('/analytics/closed-loan-details', {
          headers: {
          },
          params: queryParams 
        })
        .then((res) => {
          setclosedData(res?.data?.emiDetails?.closedlonas||[]);
          setTotalFetchRows(res?.data?.emiDetails?.pagination?.totalRows || 0);
        })
        .catch((error) => {
        });
    
    }, [user, currentPage, rowsPerPage, productTypeSelected]); 

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlepageChange = (number) => {
    setRowsPerPage(number);
    setCurrentPage(1);
    setActivePage(number); 
   
  };
    
  const fetchingclosedData = (page = currentPage, perPage = rowsPerPage)=>{
        
        let queryParams = {
          perPage: perPage,
          pageNo: page,
        }
         let startDate, endDate;
        if(ClosedstartDate && ClosedendDate){
          startDate = moment(ClosedstartDate, 'DD MMM YYYY').format('YYYY-MM-DD');
          endDate = moment(ClosedendDate, 'DD MMM YYYY').format('YYYY-MM-DD')
        } else {
          startDate = moment().startOf('month').format('YYYY-MM-DD');
          endDate = moment().format('YYYY-MM-DD');
        }
    queryParams.startDate = startDate;
    queryParams.endDate = endDate + " 23:59:59";
        
       
    if (productTypeSelected && productTypeSelected !== "all") {
      queryParams.loanType = Number(productTypeSelected);
    }
    axiosInstance.get('/analytics/closed-loan-details', {
          params: queryParams,
          headers: {
          },
        })
        .then((res) => {
    
         
          setclosedData(res?.data?.emiDetails?.closedlonas || []);
          setTotalFetchRows(res?.data?.emiDetails?.pagination?.totalRows || 0);
      

        })
        .catch((error) => {
          alert(error?.response?.data?.message)
          console.error("Error fetching filtered data:", error);
        });
       }
       
       function formatNumberWithCommas(number) {
        return number?.toLocaleString('en-IN'); 
      }


      const handleDownloadList=()=>{
        const currentDate = new Date();
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const year = String(currentDate.getFullYear());
        const formattedDate = `${day}-${month}-${year}`;
        document.getElementById("downloadButton").disabled=true;
        document.getElementById("downloadButton").innerText="Wait....";
        document.getElementById("downloadButton").style.backgroundColor="#D22129";
        document.getElementById("downloadButton").style.color= "white";
        document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
        document.getElementById("downloadButton").style.fontSize= "15px";
        document.getElementById("downloadButton").style.width= "130px";
        document.getElementById("downloadButton").style.cursor= "pointer";
        document.getElementById("downloadButton").style.height= "34px";
        document.getElementById("downloadButton").style.borderRadius= "5px";
        document.getElementById("downloadButton").style.textAlign= "center";
        // document.getElementById("downloadButton").style.marginLeft="150px";
        document.getElementById("downloadButton").style.backgroundImage = "none"
    
        let queryParams = {}

        
        if(ClosedstartDate && ClosedendDate){
          const formattedStartDate = moment(ClosedstartDate, 'DD MMM YYYY').format('YYYY-MM-DD');
          const formattedEndDate = moment(ClosedendDate, 'DD MMM YYYY').format('YYYY-MM-DD') + " 23:59:59";
    
        queryParams.startDate = formattedStartDate;
        queryParams.endDate = formattedEndDate;
        }




        const startDateFrom = moment().startOf('month');
        const endDateTo = moment();
    
        // Format the dates to the desired format
        const formattedStartDate = startDateFrom.format('YYYY-MM-DD');
        const formattedEndDate = endDateTo.format('YYYY-MM-DD')+ " 23:59:59";
        
        if (formattedStartDate && formattedEndDate) {
          queryParams.startDate = formattedStartDate;
          queryParams.endDate = formattedEndDate;
        }


        if (productTypeSelected && productTypeSelected !== "all") {
          queryParams.loanType = Number(productTypeSelected);
        }
        
        axiosInstance.get("/excel/closedloans", {
          params: queryParams,
          responseType: 'arraybuffer',
          headers: {
          }
      }).then((res)=>{
        setTimeout(() => {
          document.getElementById("downloadButton").disabled=false
          document.getElementById("downloadButton").innerText="Export";
          document.getElementById("downloadButton").style.paddingLeft = "30px";
          document.getElementById("downloadButton").style.backgroundColor="#D22129";
          document.getElementById("downloadButton").style.color= "white";
          document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
          document.getElementById("downloadButton").style.fontSize= "15px";
          document.getElementById("downloadButton").style.width= "130px";
          document.getElementById("downloadButton").style.cursor= "pointer";
          document.getElementById("downloadButton").style.height= "34px";
          document.getElementById("downloadButton").style.borderRadius= "5px";
          document.getElementById("downloadButton").style.textAlign= "center";
          // document.getElementById("downloadButton").style.marginLeft= "30px";
          document.getElementById("downloadButton").style.backgroundImage = `url(${download})`
          document.getElementById("downloadButton").style.backgroundRepeat  ='no-repeat' 
          // document.getElementById("downloadButton").style.backgroundPositionY  ='20px' 
          document.getElementById("downloadButton").style.backgroundSize  ='15px' 
          document.getElementById("downloadButton").style.backgroundPosition  ='10px 10px'
    
        }, 2000);
        const blob = new Blob([res.data], { type: "application/xlsx", });
        const url= window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href =url
        link.download = `${formattedDate}.xlsx`;
    
        document.body.appendChild(link);
    
        link.click();
    
        document.body.removeChild(link);
      }
        
      ).catch((error)=>{
        alert("Error Downloading")
        document.getElementById("downloadButton").innerText="Error..";
        document.getElementById("downloadButton").style.backgroundColor="#D22129";
        document.getElementById("downloadButton").disabled=false
          document.getElementById("downloadButton").style.paddingLeft = "30px";
          document.getElementById("downloadButton").style.backgroundColor="#D22129";
          document.getElementById("downloadButton").style.color= "white";
          document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
          document.getElementById("downloadButton").style.fontSize= "15px";
          document.getElementById("downloadButton").style.width= "130px";
          document.getElementById("downloadButton").style.cursor= "pointer";
          document.getElementById("downloadButton").style.height= "34px";
          document.getElementById("downloadButton").style.borderRadius= "5px";
          document.getElementById("downloadButton").style.textAlign= "center";
          // document.getElementById("downloadButton").style.marginLeft= "30px";
          document.getElementById("downloadButton").style.backgroundImage = `url(${download})`
          document.getElementById("downloadButton").style.backgroundRepeat  ='no-repeat' 
          // document.getElementById("downloadButton").style.backgroundPositionY  ='20px' 
          document.getElementById("downloadButton").style.backgroundSize  ='15px' 
          document.getElementById("downloadButton").style.backgroundPosition  ='10px 10px'
        setTimeout(() => {
          document.getElementById("downloadButton").disabled=false
          document.getElementById("downloadButton").innerText="Export";
          // document.getElementById("downloadButton").style.paddingLeft = "30px";
          document.getElementById("downloadButton").style.backgroundColor="#D22129";
          document.getElementById("downloadButton").style.color= "white";
          document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
          document.getElementById("downloadButton").style.fontSize= "15px";
          document.getElementById("downloadButton").style.width= "130px";
          document.getElementById("downloadButton").style.cursor= "pointer";
          document.getElementById("downloadButton").style.height= "34px";
          document.getElementById("downloadButton").style.borderRadius= "5px";
          document.getElementById("downloadButton").style.textAlign= "center";
          // document.getElementById("downloadButton").style.marginLeft= "30px";
          document.getElementById("downloadButton").style.backgroundImage = `url(${download})`
          document.getElementById("downloadButton").style.backgroundRepeat  ='no-repeat' 
          // document.getElementById("downloadButton").style.backgroundPositionY  ='20px' 
          document.getElementById("downloadButton").style.backgroundSize  ='20px' 
          document.getElementById("downloadButton").style.backgroundPosition  ='15px 10px'
        }, 1000);
      })
      } 
    


  return (
    <div style={{width:"100%",backgroundColor:'white',height:'130%'}}>



    <p style={{textAlign:"center",fontFamily:'Inter-Medium',color:'#667085',fontSize:'25px'}}>Closed Loans</p>



<div style={{ display: 'flex' }}>

<div style={{ height:'30px',width:'15em', borderRadius: '20px',marginRight:"60px",marginTop:'-2px'}}>
<DatePicker
style={{ height:'33px', BorderRadius: '5px',padding: '2px', backgroundRepeat: 'no-repeat',
backgroundPosition: '5px center',
backgroundSize: '15px 15px', backgroundImage: `url(${calender})`, paddingLeft: '30px',fontSize:"14px",fontWeight:"normal", border:'1px solid #ccc'}}
placeholder="Select date range"
allowClear={true}
format="DD MMM YYYY"
onChange={(dates, dateStrings) => {

   
 setClosedStartDateFrom(dateStrings?.validatedValue[0])
 setclosedEndDateTo(dateStrings?.validatedValue[1])
}}
range
/>
</div>

<div > 
<button style={{display: 'flex', alignItems: 'center',width:'130px',backgroundColor:'#D22129',height:'34px',borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter-Medium",paddingLeft:'10px'}}
onClick={() => {
  if (currentPage !== 1) {
    setCurrentPage(1);
  } else {
    fetchingclosedData(1, rowsPerPage);
  }
}}
>
Search Results
</button>
</div>

<div style={{marginLeft:'40px'}}>
<div style={{backgroundColor:'#D22129',display: 'flex', alignItems: 'center',width:'130px',height:'34px',borderStyle:'none',borderRadius:"5px",fontFamily:"Inter-Medium",paddingLeft:'10px',justifyContent:'space-around',cursor:'pointer',marginRight:'20px'}}
id="downloadButton"   onClick={() => handleDownloadList()} >

<img src={download} style={{height:'20px',marginLeft:'8px'}} alt=""/> 
<span style={{fontFamily:"Inter-Medium",color:'white',paddingRight:"15px"}}>Export</span>

</div></div>


</div>



<table className='tables' style={{marginRight:'10px'}}>
  <thead className='table-heading'>
    <tr>
      <th style={{ fontSize: '14px', cursor: 'pointer', width: '8px%', fontFamily: "Inter-Medium", paddingLeft: '10px' }}>Loan Id</th>
      <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium" }}>Full Name</th>
      <th style={{ fontSize: '14px', cursor: 'pointer', width: '15px%', fontFamily: "Inter-Medium" }}>Inst Name</th>
      <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium" }}>Loan Amt</th>
      <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium" }}>Closed Date</th>
      <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium" }}>Last Emi Date</th>
     
    </tr>
  </thead>
  
  <tbody className='table-body'>
    
            { Closeddata?.map((item, index) => (
     <tr className="table-row" key={index} style={{ lineHeight:"25px",backgroundColor:'white'}}>
         <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '10px' }}>{item.legacy_loan_id?item.legacy_loan_id:'-'}</td>
        <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.full_name?item.full_name:'-'}</td>
        <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.name?item.name:'-'}</td>
        <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>₹{item.loan_amount ?formatNumberWithCommas(Math.round(item.loan_amount)):'-'}</td>
        <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.closed_date ? new Date(item.closed_date).toISOString().split('T')[0] : '-'}</td>               
       <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.last_emi_payment_date ? new Date(item.last_emi_payment_date).toISOString().split('T')[0] : '-'}</td>

      </tr> 
    ))}
  </tbody>
</table>
        {Closeddata?.length > 0 ? (
          <>
            <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "5px",
              flexWrap: "wrap",
              gap: "10px",
              fontFamily: "Inter",
              backgroundColor: "white", 
            }}>
              <div style={{
                fontWeight: "bold",
                fontSize: "14px",
                whiteSpace: "nowrap",
                color: "#344054"
              }}>
                {totalFetchRows > 0 ? (
                  <>
                    Showing {(currentPage - 1) * rowsPerPage + 1}-
                    {Math.min(currentPage * rowsPerPage, totalFetchRows)} records of {totalFetchRows} |
                  </>
                ) : (
                  "No Records"
                )}
              </div>

              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                whiteSpace: "nowrap"
              }}>
                <span style={{ fontWeight: "600", color: "#344054" }}>
                  Rows Per Pages :
                </span>
                <div style={{ display: "flex", gap: "4px" }}>
                  {[15, 50, 100, 500].map((size) => (
                    <span
                      key={size}
                      onClick={() => handlepageChange(size)}
                      style={{
                        cursor: "pointer",
                        padding: "4px 8px",
                        fontSize: "14px",
                        fontWeight: 500,
                        color: activePage === size ? "#D32028" : "#344054",     
                        backgroundColor: activePage === size ? "#FFF2F3" : "", 
                        borderRadius: "8px",
                        transition:"none"
                      }}
                    >
                      {size}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div style={{ backgroundColor: 'white', width: '100%', padding: '0 10px' }}>
            <PaginationTable
              startPage={currentPage}
              rowsPerPage={rowsPerPage}
              totalRows={totalFetchRows}
              paginate={paginate}
              handlepageChange={handlepageChange}
            />
            </div>
          </>
        ) : null}
    </div>
  )
}
